import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pb-24 pt-48">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-12" style={{ fontFamily: 'Outfit, sans-serif' }}>
            FAQs
          </h1>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Is your honey raw?</h3>
              <p>Yes — our honey is raw Australian honey. It is only lightly strained and gently kept around natural hive temperature (approximately 35°C) to assist with bottling, without heavy processing or pasteurisation. This helps keep the honey as close to how it is naturally found in the hive as possible.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>2. What's the difference between raw and pasteurised honey?</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Raw honey:</strong> Natural, may crystallise faster, retains more beneficial compounds.</li>
                <li><strong>Pasteurised honey:</strong> Gently heated to improve clarity and shelf life, but may lose some natural properties.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Why has my honey crystallised?</h3>
              <p className="mb-2">Crystallisation is completely natural and a sign of quality. It happens when glucose separates from water.</p>
              <p>To return it to liquid, place the jar in warm (not boiling) water and stir gently.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Does honey expire?</h3>
              <p>Honey doesn't spoil if stored properly. It may change colour or crystallise over time, but it remains safe to eat.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Where does your honey come from?</h3>
              <p>Our honey producers specify the region, floral source and beekeeper practices. We only source Victoria.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>6. What is the difference between Manuka and regular honey?</h3>
              <p>Manuka honey comes from bees that pollinate the Manuka bush (native to Australia and New Zealand). It's known for higher antibacterial properties and often carries a rating system such as MGO or UMF.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>7. Do you add sugar to your honey?</h3>
              <p className="mb-2">Absolutely not 🐝🍯</p>
              <p className="mb-2">Ricky's Bees honey is 100% pure Australian honey — nothing added, ever. That means no sugar, no syrups, and no fillers of any kind. What you taste in each jar is exactly what the bees have naturally created.</p>
              <p>We also keep each honey variety true to its own natural character, so we don't mix different honeys together to create a certain colour, texture, or flavour. Every jar reflects the unique blossoms the bees have foraged.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Is honey safe for children?</h3>
              <p>Honey should not be given to infants under 12 months due to the risk of infant botulism. It is safe for older children and adults.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>9. What do the different colours mean?</h3>
              <p className="mb-2">Honey colour depends on floral source:</p>
              <ul className="list-disc pl-6 space-y-2 mb-2">
                <li><strong>Light</strong> (e.g. River Bloom) - mild, delicate flavour</li>
                <li><strong>Amber</strong> (e.g. Golden Morning) - balanced and aromatic</li>
                <li><strong>Dark</strong> (e.g. Wild Forest) - stronger, richer flavour</li>
              </ul>
              <p>Darker honeys often contain higher antioxidant levels.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>10. Is local honey better for allergies?</h3>
              <p>Some people believe local honey may help with seasonal allergies due to trace pollen exposure, though scientific evidence is limited.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>11. How should honey be stored?</h3>
              <p>Keep tightly sealed at room temperature. Avoid refrigeration as it speeds up crystallisation.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>12. Is your honey sustainably produced?</h3>
              <p className="mb-2">We look for beekeepers who prioritise:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Ethical hive management</li>
                <li>Bee health and biodiversity</li>
                <li>Minimal processing</li>
                <li>No added sugars or syrups</li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
